import React from 'react'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const Membership = () => {
  const { t } = useLang()
  const m = t.acct.manage.membership

  return (
    <div className="app-shell">
      <Sidebar active="members"/>
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.membership]}/>
        <div className="content">
          <div className="kicker accent" style={{ marginBottom: 10 }}>◆ {m.member_since}</div>
          <h1 className="h-display" style={{ fontSize: 36, margin: 0 }}>
            {m.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{m.title_2_brand}</span>
          </h1>
          <p style={{ fontSize: 15, color: "var(--muted)", margin: "8px 0 24px", maxWidth: 540 }}>
            {m.plan_blurb}
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 18, marginBottom: 18 }}>
            {/* Plan card */}
            <div className="tile dark" style={{ padding: 28, position: "relative", overflow: "hidden" }}>
              <div style={{ position: "absolute", inset: 0, opacity: 0.18 }} className="roof-pattern"/>
              <div style={{ position: "relative", zIndex: 2 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                  <div>
                    <div className="font-mono" style={{ fontSize: 10, color: "#E68A5C", letterSpacing: "0.1em" }}>{m.plan_name_label}</div>
                    <div className="h-display" style={{ fontSize: 32, color: "var(--cream)", marginTop: 4 }}>{m.plan_name}</div>
                  </div>
                  <span style={{ padding: "4px 10px", borderRadius: 999, background: "rgba(122,140,108,0.25)", color: "#A6B59A", fontFamily: "'Geist Mono', monospace", fontSize: 10, fontWeight: 600 }}>● {m.plan_active}</span>
                </div>

                {/* Usage */}
                <div style={{ marginTop: 22, padding: 18, borderRadius: 12, background: "rgba(245,239,230,0.06)", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                  <div>
                    <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{m.visits}</div>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 4 }}>
                      <span className="h-display" style={{ fontSize: 30, color: "var(--cream)" }}>1</span>
                      <span style={{ fontSize: 13, color: "rgba(245,239,230,0.55)" }}>{m.used}</span>
                    </div>
                    <div style={{ height: 4, background: "rgba(245,239,230,0.1)", borderRadius: 999, marginTop: 8 }}>
                      <div style={{ width: "50%", height: "100%", background: "#E68A5C", borderRadius: 999 }}/>
                    </div>
                  </div>
                  <div>
                    <div className="font-mono" style={{ fontSize: 10, color: "rgba(245,239,230,0.55)" }}>{m.small_jobs}</div>
                    <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 4 }}>
                      <span className="h-display" style={{ fontSize: 30, color: "var(--cream)" }}>14</span>
                      <span style={{ fontSize: 13, color: "rgba(245,239,230,0.55)" }}>{m.this_year} · {m.unlimited}</span>
                    </div>
                    <div style={{ height: 4, background: "rgba(245,239,230,0.1)", borderRadius: 999, marginTop: 8 }}>
                      <div style={{ width: "70%", height: "100%", background: "#7A8C6C", borderRadius: 999 }}/>
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                  <button className="btn btn-primary" style={{ padding: "10px 16px", fontSize: 13 }}>{m.upgrade}</button>
                  <button className="btn" style={{ padding: "10px 16px", fontSize: 13, background: "rgba(245,239,230,0.08)", color: "var(--cream)", border: "1px solid rgba(245,239,230,0.2)" }}>{m.manage_plan}</button>
                </div>
              </div>
            </div>

            {/* Payment method */}
            <div className="tile" style={{ padding: 22 }}>
              <h3 className="h-display" style={{ fontSize: 18, margin: "0 0 14px" }}>{m.payment}</h3>
              <div style={{ padding: 18, background: "linear-gradient(135deg, var(--cocoa-2), var(--cocoa))", color: "var(--cream)", borderRadius: 14, position: "relative", overflow: "hidden", marginBottom: 14 }}>
                <div style={{ position: "absolute", right: -20, top: -20, width: 80, height: 80, borderRadius: "50%", background: "rgba(194,85,45,0.25)" }}/>
                <div className="font-mono" style={{ fontSize: 9, color: "rgba(245,239,230,0.5)", letterSpacing: "0.15em", marginBottom: 18 }}>{m.default_card}</div>
                <div className="font-mono" style={{ fontSize: 18, letterSpacing: "0.15em" }}>•••• •••• •••• 4242</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginTop: 14 }}>
                  <div>
                    <div className="font-mono" style={{ fontSize: 9, color: "rgba(245,239,230,0.5)" }}>{m.cardholder}</div>
                    <div style={{ fontSize: 12 }}>MARIA LOPEZ</div>
                  </div>
                  <span style={{ padding: "3px 7px", background: "var(--cream)", color: "var(--cocoa)", borderRadius: 4, fontFamily: "'Geist Mono', monospace", fontSize: 10, fontWeight: 600 }}>VISA</span>
                </div>
              </div>
              <button className="btn btn-ghost" style={{ width: "100%", justifyContent: "center", fontSize: 12, padding: "9px 14px" }}>
                <Ico.plus width="12" height="12"/> {m.backup_card}
              </button>
            </div>
          </div>

          {/* Invoice history */}
          <div className="tile" style={{ padding: 22 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
              <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{m.billing_history}</h3>
              <a href="#" className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)", textDecoration: "none" }}>{m.download_all}</a>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1.4fr 100px 90px 80px 70px", padding: "10px 14px", borderRadius: 8, background: "var(--cream-2)", fontFamily: "'Geist Mono', monospace", fontSize: 10, color: "var(--muted)" }}>
              <span>{m.invoice}</span><span>{m.date}</span><span>{m.amount}</span><span>{m.status}</span><span/>
            </div>
            {m.invoices.map((r, i) => (
              <div key={r.id} style={{ display: "grid", gridTemplateColumns: "1.4fr 100px 90px 80px 70px", padding: "12px 14px", borderTop: "1px solid var(--line)", alignItems: "center", fontSize: 13 }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{r.what}</div>
                  <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{r.id}</span>
                </div>
                <span className="font-mono" style={{ fontSize: 12 }}>{r.date}</span>
                <span className="font-mono" style={{ fontSize: 13, fontWeight: 600 }}>{r.amt}</span>
                <span className="status-pill pill-done" style={{ padding: "2px 7px" }}><span className="dot"/>{m.paid}</span>
                <a href="#" className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)", textDecoration: "none" }}>PDF ↓</a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ManageMembershipPage() {
  return <Membership />
}
